import { render, staticRenderFns } from "./InnerFuneral.vue?vue&type=template&id=5da5467d&scoped=true&"
import script from "./InnerFuneral.vue?vue&type=script&lang=js&"
export * from "./InnerFuneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5467d",
  null
  
)

export default component.exports